import { useParams } from 'react-router';
import { CampaignId } from 'modules/domains/campaign';

/**
 * Grabs the campaign id from the campaign editor URL
 */
export const useCampaignIdParam = () => {
  const { id = '0' } = useParams<{ id?: string }>();
  const campaignId: CampaignId = parseInt(id, 10);

  return campaignId;
};
